<script lang="ts" setup>
import { NoticeBlockIconType, NoticeBlockSize } from '@/types/NoticeBlockLegacy'

defineProps({
	size: {
		type: String,
		default: NoticeBlockSize.Default,
	},
	icon: {
		type: String,
		default: NoticeBlockIconType.Default,
	},
})
</script>

<template>
	<div :class="['bs-notice-block', size ? `bs-notice-block--${size}` : '']">
		<i
			v-if="icon"
			:class="['bs-notice-block__icon', `bs-notice-block__icon--${icon}`]"
		></i>
		<div class="bs-notice-block__text">
			<div class="bs-notice-block__text__title">
				<slot name="title"></slot>
			</div>
			<div class="bs-notice-block__text__description">
				<slot name="description"></slot>
			</div>
		</div>
	</div>
</template>
